import { Injectable } from '@angular/core';
import { GlobalConstants } from 'src/app/shared/models/globalConstants';

/* IES-5562: Quick Enroll session token, bound to the employer and billing schedule of the Quick Enroll link. */
export interface QuickEnrollSession {
    token: string;
    employerNo: string;
    billingScheduleNo: string;
}

@Injectable({
    providedIn: 'root'
})
export class QuickEnrollSessionService {

    get(): QuickEnrollSession | null {
        return JSON.parse(sessionStorage.getItem(GlobalConstants.QE_SESSION_KEY) || 'null');
    }

    start(token: string, employerNo: string, billingScheduleNo: string) {
        sessionStorage.setItem(GlobalConstants.QE_SESSION_KEY, JSON.stringify({ token, employerNo, billingScheduleNo }));
    }

    /* IES-5562: removes the session and the enrollee data that was loaded under it, optionally leaving a message for the next page load. */
    clear(showMessage = false) {
        if (showMessage) {
            sessionStorage.setItem(GlobalConstants.QE_SESSION_MESSAGE_KEY, 'true');
        }
        sessionStorage.removeItem(GlobalConstants.QE_SESSION_KEY);
        sessionStorage.removeItem(GlobalConstants.QE_EMPLOYEE_ID_KEY);
        sessionStorage.removeItem(GlobalConstants.QE_FORM_DATA_KEY);
    }

    /* IES-5562: true once after a session was dropped, so the Quick Enroll page can tell the user. */
    consumeMessage(): boolean {
        const pending = !!sessionStorage.getItem(GlobalConstants.QE_SESSION_MESSAGE_KEY);
        sessionStorage.removeItem(GlobalConstants.QE_SESSION_MESSAGE_KEY);
        return pending;
    }

    /* IES-5562: the session is valid for one employer and billing schedule only. */
    isFor(employerNo: string, billingScheduleNo: string): boolean {
        const session = this.get();
        return !!session && session.employerNo === employerNo && session.billingScheduleNo === billingScheduleNo;
    }

    isProtectedUrl(url: string): boolean {
        return GlobalConstants.QE_PROTECTED_API_PATHS.some(path => url.includes(path));
    }
}
